import { render } from "./MainLayout.vue?vue&type=template&id=e7f806c8"
const script = {}

import exportComponent from "D:\\AppV5\\DangKyXetTuyen\\vueapp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__